/*
 * Module for Snag Form page
 */
rs.module("content/development/snagform",

    [],

    function () {

        // Initialize the page
        function initialize(jsSelectors) {

            var form = $.js(jsSelectors.form);
            var modeSelectionFormRadio = form.js(jsSelectors.modeSelectionFormRadio);
            var modeSelectionRadioList = form.js(jsSelectors.modeSelectionRadioList);
            var subheading = form.js(jsSelectors.subheading);
            var memo = form.js(jsSelectors.memo);
            var formSelected = modeSelectionFormRadio.is(":checked");

            showHideFields();

            modeSelectionRadioList.change(function () {
                formSelected = modeSelectionFormRadio.is(":checked");
                showHideFields();
            });

            function showHideFields() {
                if (formSelected) {
                    subheading.show();
                    memo.hide();
                }
                else {
                    memo.show();
                    subheading.hide();
                }
            }
        }

        var exports = {
            initialize: initialize,
        };

        return exports;
    }
);